<template>
  <div>
    <h2 class="page-title-bar">
      <img
        src="@/assets/img/camera.png"
        style="margin-right: 10px; width:30px"
      />
      {{ $t("Shelf Tasks") }}
    </h2>
    <div class="mt-5">
      <v-tabs v-model="tab" background-color="transparent" class="shelf-tabs" @change="onTabChange">
        <v-tab class="tabs" href="#ALL">{{ $t("All") }}</v-tab>
        <v-tab class="tabs" href="#OPEN">{{ $t("Open") }}</v-tab>
        <v-tab class="tabs" href="#RESOLVED">{{ $t("Resolved") }}</v-tab>
        <v-tab class="tabs" href="#PENDING">{{ $t("Pending") }}</v-tab>
        <v-tab class="tabs" href="#NO_ISSUE">{{ $t("No Issue") }}</v-tab>
      </v-tabs>
      <ShelfTabItem class="mt-5" :value="tab" :floor-items="floorItems" :floor-map="floorMap" />
    </div>
  </div>
</template>
<script>
import ShelfTabItem from './ShelfTabItem.vue'
import codes from '@/plugins/codes'
import { mapGetters } from 'vuex'

export default {
  components: {
    ShelfTabItem: ShelfTabItem
  },
  data: () => ({
    tab: 'ALL',
    shelfDetails: {},
    floorItems: [],
    floorMap: {}
  }),
  computed: {
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    })
  },
  methods: {
    onTabChange (value) {
      this.tab = value
    },

    getDepDetails () {
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.store.code
      }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getDepDetail.method,
          codes.requests.getDepDetail.url,
          config
        )
        .then((res) => {
          if (res.status !== 204) {
            res.data.linkedShelvesDeptList.forEach((data) => {
              this.floorItems.push(data.floor)
              this.floorMap[data.floor] = data.section
            })
          } else {
            this.floorItems = []
            this.floorMap = {}
          }
        })
    }
  },
  mounted () {
    this.getDepDetails()
  }
}
</script>
<style scoped>
.shelf-tabs ::v-deep .v-tabs-bar,
.shelf-tabs ::v-deep .v-tabs-bar__content,
.shelf-tabs ::v-deep .v-slide-group__wrapper {
  background-color: transparent !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

::v-deep .v-slide-group__wrapper {
  height: 34px;
  border-bottom: 1px solid #e5e7eb;
}

::v-deep .v-slide-group__content {
  gap: 18px;
}

.tabs {
  text-transform: none;
  color: #2d2e7b;
  min-width: 0;
  padding: 0;
}

::v-deep .v-tabs-slider-wrapper {
  height: 2px !important;
  color: #2d2e7b;
}

::v-deep .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  background-color: #fff !important;
}
</style>
